import type { StaticFile } from "@/types/staticFiles"
import { createService } from "../api/api-factory"
import { Request } from "@/utils/request"

const api = new Request("/v1/StaticFiles/")

export default createService("staticFiles", {
  async getAppIcons() {
    return await api.get<StaticFile[]>("AssetIcons")
  }
})
